import React from "react";
import ReviewCard from "../../components/ReviewCard/ReviewCard";
import { sortByOrderAscending } from "../../helper/helper";

const HopperCafeReviewPage = ({ components }) => {
    const getComponents = (component) => {
        switch (component.ID) {
            case "HopperCafeReviewPage-header":
                return <div className="HopperCafeReviewPage-subheader">{component?.Props?.text}</div>
            case "HopperCafeReviewPage-subheader":
                return <div className="HopperCafeReviewPage-header">{component?.Props?.text}</div>
            case "HopperCafeReviewPage-grid":
                return <div className="HopperCafeReviewPage-grid">
                    {component?.Data?.map((data, key) => {
                        return (
                            <ReviewCard
                                data={data}
                                key={key} />
                        )
                    })}
                </div>
            default:
                return <div />
        }

    }
    return (
        <div className="HopperCafeReviewPage">
            {sortByOrderAscending(components).map((component, key) => {
                return (
                    getComponents(component)
                )
            })}
        </div>
    )
}
export default HopperCafeReviewPage